import React              from 'react';
import dayjs              from 'dayjs';
import { setLocale }      from '@widesk-core/locale';
import { useLocation }    from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export type SupportedLanguage = 'en' | 'fr'

const useTranslations = () => {
	const { t, i18n } = useTranslation();
	const location = useLocation();

	const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['en', 'fr']

	const setAppTitle = (appTitle: string) => {
		const appTitleHTMLElement = document.getElementById('appTitle');
		if (appTitleHTMLElement) {
			appTitleHTMLElement.textContent = appTitle;
		}
	}

	const setHTMLLanguage = (language: SupportedLanguage) => {
		document.documentElement.setAttribute('lang', language);
	}

	const validateLanguage = () => {
		const languageFromUrl = location.pathname.split('/')[1];
		
        // Si la langue est présente dans l'url
        if (languageFromUrl === 'en' || languageFromUrl === 'fr') {
			// Si la langue de l'application est différente de la langue présente dans l'url, 
			// alors on set la langue de l'application en fonction de la langue de l'url
            if (i18n.language !== languageFromUrl) {
				setLocale(languageFromUrl);
                i18n.changeLanguage(languageFromUrl);
				dayjs.locale(languageFromUrl);
            }
        } 
        // Si la langue n'est pas présente dans l'url
        else {
			const navigatorLanguagePrefix = navigator.language.split('-')[0];
            const navigatorLanguage = navigatorLanguagePrefix === 'fr' ? 'fr' : 'en';
            // Si la langue de l'application est différente de la langue du navigateur, 
			// alors on set la langue de l'application en fonction de la langue du navigateur
            if (i18n.language !== navigatorLanguage) {
				setLocale(navigatorLanguage);
                i18n.changeLanguage(navigatorLanguage);
				dayjs.locale(navigatorLanguage);
            }
        }
	};

	const getNavigationTranslation = (pageKey: string, type: 'label' | 'path' | 'hash') =>  {
		if (type === 'path') {
			const pagePath = t(`pages.${pageKey}.${type}`);
			return `/${i18n.language}${pagePath}`;
		}

		return t(`pages.${pageKey}.${type}`);
	};
	
	const getTagTranslation = (pageKey: string, tagKeys: string[]) => tagKeys.map(tagKey => t(`pages.${pageKey}.searchTags.${tagKey}`));

	React.useEffect(() => {
		setAppTitle(t('app.title'));
		setHTMLLanguage(i18n.language as SupportedLanguage);
	}, [i18n.language]);
	
	return {
		SUPPORTED_LANGUAGES,
		getNavigationTranslation,
		getTagTranslation,
		validateLanguage,
	}
}

export default useTranslations;